const showStream = ({ embed }) => {
  $('.js-service-header__stream').show()
  $('.js-service-header__between-services').hide()

  $('.js-service-container__stream').show()
  $('.js-service-container__between-services').hide()

  $('.js-service-embed').html(embed)

  $('.js-service__during').show()
}

const hideStream = () => {
  $('.js-service-header__stream').hide()
  $('.js-service-header__between-services').show()

  $('.js-service-container__stream').hide()
  $('.js-service-container__between-services').show()

  $('.js-service-embed').html('')

  $('.js-service__during').hide()
}

export { showStream, hideStream }
